namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoHd6Form {
        PromoCampaign: Serenity.LookupEditor;
        PmGroupId: Serenity.StringEditor;
        PmGroupDesc: Serenity.StringEditor;
        StartPromoDate: Serenity.DateEditor;
        EndPromoDate: Serenity.DateEditor;
        PromoTimeFg: Serenity.RadioButtonEditor;
        StartPromoTime: Common.EditTimeEditor;
        EndPromoTime: Common.EditTimeEditor;
        PromoDayFg: Serenity.RadioButtonEditor;
        PromoDay: Serenity.LookupEditor;
        PromoShopFg: Serenity.RadioButtonEditor;
        PromoShop: Serenity.LookupEditor;
        PromoCustFg: Serenity.EnumEditor;
        PromoMb: Serenity.LookupEditor;
        PromoStatus: Serenity.BooleanEditor;
        PromoApproveFg: Serenity.BooleanEditor;
        VenderSharing: Serenity.DecimalEditor;
        Item6List: PsAdvPromoItem6Editor;
        Item6ExList: PsAdvPromoItem6ExemptEditor;
    }

    export class PsAdvPromoHd6Form extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoHd6';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoHd6Form.init)  {
                PsAdvPromoHd6Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = Common.EditTimeEditor;
                var w5 = s.EnumEditor;
                var w6 = s.BooleanEditor;
                var w7 = s.DecimalEditor;
                var w8 = PsAdvPromoItem6Editor;
                var w9 = PsAdvPromoItem6ExemptEditor;

                Q.initFormType(PsAdvPromoHd6Form, [
                    'PromoCampaign', w0,
                    'PmGroupId', w1,
                    'PmGroupDesc', w1,
                    'StartPromoDate', w2,
                    'EndPromoDate', w2,
                    'PromoTimeFg', w3,
                    'StartPromoTime', w4,
                    'EndPromoTime', w4,
                    'PromoDayFg', w3,
                    'PromoDay', w0,
                    'PromoShopFg', w3,
                    'PromoShop', w0,
                    'PromoCustFg', w5,
                    'PromoMb', w0,
                    'PromoStatus', w6,
                    'PromoApproveFg', w6,
                    'VenderSharing', w7,
                    'Item6List', w8,
                    'Item6ExList', w9
                ]);
            }
        }
    }
}
